var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1699 6C12.1699 6.78793 12.0147 7.56815 11.7132 8.2961C11.4117 9.02405 10.9697 9.68549 10.4126 10.2426C9.85541 10.7998 9.19398 11.2417 8.46602 11.5433C7.73807 11.8448 6.95785 12 6.16992 12C5.38199 12 4.60177 11.8448 3.87382 11.5433C3.14587 11.2417 2.48443 10.7998 1.92728 10.2426C1.37013 9.68549 0.928173 9.02405 0.626645 8.2961C0.325116 7.56815 0.169922 6.78793 0.169922 6C0.169922 4.4087 0.802063 2.88258 1.92728 1.75736C3.0525 0.632141 4.57862 0 6.16992 0C7.76122 0 9.28734 0.632141 10.4126 1.75736C11.5378 2.88258 12.1699 4.4087 12.1699 6ZM7.34792 6L9.35192 8.00333L8.17326 9.182L6.16992 7.178L4.16659 9.18133L2.98792 8.00267L4.99126 5.99933L2.98792 3.996L4.16659 2.818L6.16992 4.82L8.17326 2.81667L9.35192 3.99467L7.34792 6Z",
    fill: "#707A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.5e8c6c28c964cde390c7bdda5fb9b83a.svg";
export { ForwardRef as ReactComponent };